import React, { PropsWithChildren, useCallback, useContext, useState } from 'react';
import { Pressable, ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { CustomText } from '@/components/CustomText';
import { Text } from 'react95-native-rabbl';
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { ExternalLink } from '@/components/ExternalLink';
import { Community } from "@/types/community";
import { useDispatch } from 'react-redux';
import { RelativePathString, useRouter } from 'expo-router';
import { setDomain } from '@/state/user';
import { setDrawerOpen } from '@/state/user';
import { AppContext } from '@/components/AppContext';

interface Props {
  community: Community,
  ensureDrawerDismissed?: boolean,
  asChild?: boolean,
  href?: string,
};

export function RabblLink({ community, ensureDrawerDismissed = false, asChild = false, href, children }: PropsWithChildren<Props>) : React.ReactNode {
  const router = useRouter();
  const dispatch = useDispatch();
  const { showSpinner, hideSpinner } = useContext(AppContext);

  const perform = () => {
    if (community.id == -1) {
      AppUtilities.setLocalDataDomain(community.domain);
      dispatch(setDomain(AppConstants.HOST));
    } else {
      AppUtilities.setLocalDataDomain(community.domain);
      dispatch(setDomain(community.domain));
    }
    router.dismissAll();
    router.replace("/");
  };

  const appHandler = () => {
    AppUtilities.info("RabblLink redirecting to " + community.domain);
    if (ensureDrawerDismissed) {
      let doHideSpinner = true;
      try {
        showSpinner();
        doHideSpinner = AppUtils.closeDrawerActionRedux(
          perform,
          hideSpinner,
          dispatch,
          setDrawerOpen,
        );
      } finally {
        if (doHideSpinner) {
          hideSpinner();
        }
      }
    } else {
      perform();
    }
  };

  if (AppUtilities.isWeb()) {
    let link = community.id == -1 ? AppUtilities.getActualHostLink(true, true) : AppUtils.getCommunityURL(community);
    if (href) {
      link += href;
    } else {
      link += "/";
    }
    return (
      <ExternalLink
        href={link}
        asChild={asChild}
      >
        { children }
      </ExternalLink>
    );
  } else {
    return (
      <Pressable onPress={appHandler}>
        { children }
      </Pressable>
    );
  }
};
